import { Component, Input, Output, EventEmitter, inject, ChangeDetectorRef, OnChanges } from '@angular/core';
import { FilterField } from '../generic-list/filter-field.model';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface Transaction {
  id: string;
  createdAt: string;
  monto_bruto: number;
  monto_comision: number;
  valor_comision: number;
  unit_comision: string;
  Tipo: string;
  emailreferido: string;
  telreferido: string;
  referido: string;
}

@Component({
  selector: 'app-btb-transactions-list',
  templateUrl: './btb-transactions-list.component.html',
  styleUrls: ['./btb-transactions-list.component.scss']
})
export class BtbTransactionsListComponent implements OnChanges {
   _snackBar = inject(MatSnackBar);
   cdr = inject(ChangeDetectorRef);
  @Input() transactions: Transaction[] = [];
  @Input() filterFields: FilterField[] = [];
  @Input() filteredCount: number = 0;
  @Output() filteredCountChange = new EventEmitter<number>();
  @Output() buscarPorFechasEvent = new EventEmitter<{ fechaini: string, fechafin: string }>();

  fechaini: string = '';
  fechafin: string = '';
  isLoading: boolean = false;
  
  // Fechas de la última búsqueda exitosa (para mostrar en el resumen)
  lastSearchFechaini: string = '';
  lastSearchFechafin: string = '';

  filteredTransactions: Transaction[] = [];
  activeFilters: any = {};

  ngOnInit() {
    if (!this.fechaini || !this.fechafin) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const todayStr = `${yyyy}-${mm}-${dd}`;
      
      // Fecha de inicio: día 1 del mes actual
      const firstDayStr = `${yyyy}-${mm}-01`;
      
      this.fechaini = firstDayStr;
      this.fechafin = todayStr;
    }
    
    // Carga automática de datos al inicializar
    this.loadInitialData();
  }

  private loadInitialData(): void {
    if (this.fechaini && this.fechafin) {
      this.buscarPorFechas();
    }
  }

  async buscarPorFechas(): Promise<void> {
    if (!this.fechaini || !this.fechafin) {
      this._snackBar.open('Debe especificar ambas fechas', 'Close', { duration: 5000 });
      return;
    }

    if (new Date(this.fechaini) > new Date(this.fechafin)) {
      this._snackBar.open('La fecha de inicio no puede ser mayor que la fecha de fin', 'Close', { duration: 5000 });
      return;
    }

    this.isLoading = true;

    this.buscarPorFechasEvent.emit({
      fechaini: this.fechaini,
      fechafin: this.fechafin
    });
  }

  onFilteredCountChange(count: number) {
    this.filteredCountChange.emit(count);
  }

  onFilteredItemsChange(items: Transaction[]) {
    this.filteredTransactions = items;
  }

  onActiveFiltersChange(filters: any) {
    this.activeFilters = filters;
  }

  get filteredCommission(): number {
    return this.filteredTransactions.reduce((total, transaction) => {
      return total + (transaction.monto_comision || 0);
    }, 0);
  }

  getDateRange(): string {
    if (!this.lastSearchFechaini || !this.lastSearchFechafin) {
      return '-';
    }

    const formatDate = (dateStr: string) => {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const fromFormatted = formatDate(this.lastSearchFechaini);
    const toFormatted = formatDate(this.lastSearchFechafin);

    return `${fromFormatted} - ${toFormatted}`;
  }

  stopLoading(): void {
    this.isLoading = false;
  }

  updateLastSearchDates(fechaini: string, fechafin: string): void {
    this.lastSearchFechaini = fechaini;
    this.lastSearchFechafin = fechafin;
  }

  formatCommission(transaction: Transaction): string {
    if (transaction.unit_comision === '%') {
      return `${transaction.valor_comision}%`;
    } else {
      return `${transaction.valor_comision}€`;
    }
  }

  ngOnChanges(): void {
    // Forzar detección de cambios cuando cambian las transacciones
    this.cdr.detectChanges();
  }
}
